export const ASSISTANT_NAME = 'Warbox Business AI';
export const ASSISTANT_CHAT_REGION_ID = 'warbox-ai-chat';
export const ASSISTANT_MESSAGE_MAX_LENGTH = 300;

/** Size of the closed widget (round launcher) and height of its header when open. */
export const LAUNCHER_SIZE_PX = 52;
/** Distance between the widget and the bottom-right corner of the viewport. */
export const WIDGET_EDGE_OFFSET_PX = 28;
const WIDGET_CONTENT_GAP_PX = 8;
/** Bottom space the layout reserves so page controls can scroll above the closed widget. */
export const WIDGET_RESERVED_SPACE_PX =
    LAUNCHER_SIZE_PX + WIDGET_EDGE_OFFSET_PX + WIDGET_CONTENT_GAP_PX;

export const ASSISTANT_SECTION = Object.freeze({
    CHAT: 'chat',
    WORKING_LEADS: 'working_leads',
} as const);

export type TAssistantSection =
    (typeof ASSISTANT_SECTION)[keyof typeof ASSISTANT_SECTION];

export const GREETING_KEYS = [
    'Assistant.GreetingHelp',
    'Assistant.GreetingLeads',
    'Assistant.GreetingAvailable',
];

export const GREETING_PHASE = Object.freeze({
    HIDDEN: 'hidden',
    TYPING: 'typing',
    WRITING: 'writing',
    MESSAGE: 'message',
} as const);

export type TGreetingPhase =
    (typeof GREETING_PHASE)[keyof typeof GREETING_PHASE];

export const GREETING_TIMING_MS = Object.freeze({
    INITIAL_DELAY: 900,
    TYPING: 1800,
    PER_CHARACTER: 85,
    VISIBLE: 5000,
    PAUSE: 7000,
});

export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

export const ESCAPE_KEY = 'Escape';

export const LEAD_AVATAR_FALLBACK = 'L';

export const SPEECH_PERMISSION_ERRORS = ['not-allowed', 'service-not-allowed'];

export const SHELL_HEIGHT_PROPERTY = 'height';
